import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import SelectDropdown from "../../components-react/SelectDropdown";
import PlacesSearch from "../../common-components/SearchedPlaces";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutFormData } from "../../../redux/reducers/commonApiSlice";
import { add_gym, update_gym } from "../../../data/ApiEndpoints";
import { slugify } from "../../common-data/Conversions";
import {
  fetchGymCategoriesData,
  fetchUsersData,
} from "../../../redux/reducers/dropdownApiSlice";

const validateForm = (formValues) => {
  let errors = {};

  if (!formValues.selectedGymOwner) {
    errors.selectedGymOwner = "Required!";
  }

  if (!formValues.selectedGymCategory) {
    errors.selectedGymCategory = "Required!";
  }

  if (!formValues.gymName) {
    errors.gymName = "Required!";
  }

  if (!formValues.gymSlug) {
    errors.gymSlug = "Required!";
  }

  if (!formValues.address1) {
    errors.address1 = "Required!";
  }

  if (!formValues.address2) {
    errors.address2 = "Required!";
  }

  if (!formValues.city) {
    errors.city = "Required!";
  }

  if (!formValues.state) {
    errors.state = "Required!";
  }

  if (!formValues.pincode) {
    errors.pincode = "Required!";
  } else if (formValues.pincode.toString()?.length > 7) {
    errors.pincode = "Required!";
  }

  if (!formValues.country) {
    errors.country = "Required!";
  }

  if (!formValues.lat) {
    errors.lat = "Required!";
  }

  if (!formValues.long) {
    errors.long = "Required!";
  }

  // if (!formValues.gymDescription) {
  //   errors.gymDescription = "Required!";
  // } else if (formValues.gymDescription?.length > 100) {
  //   errors.gymDescription = "Required!";
  // }

  if (formValues.wtfSharePer && Number(formValues.wtfSharePer || 0) > 100) {
    errors.wtfSharePer = "Required!";
  }

  if (!formValues.googleRating) {
    errors.googleRating = "Required!";
  } else if (Number(formValues.googleRating || 0) > 5) {
    errors.googleRating = "Rating should be out of 5!";
  }

  if (!formValues.gmbUrl) {
    errors.gmbUrl = "Required!";
  }

  if (!formValues.shortUrl) {
    errors.shortUrl = "Required!";
  }

  return errors;
};

const FitnessCenterForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoadingFormData } = useSelector((state) => state.common);
  const { usersData, gymCategories } = useSelector((state) => state.dropdown);

  const forminitials = {
    selectedGymOwner:
      isEdit && rowData?.user_id && rowData?.name
        ? { label: rowData?.name, value: rowData.user_id }
        : "",
    selectedGymCategory:
      isEdit && rowData?.category_id && rowData?.category_name
        ? { label: rowData?.category_name, value: rowData.category_id }
        : "",
    deviceID: isEdit && rowData?.device_id ? rowData.device_id : "",
    gymName: isEdit && rowData?.gym_name ? rowData.gym_name : "",
    gymSlug: isEdit && rowData?.slug ? rowData.slug : "",

    searchedLocation: "",
    address1: isEdit && rowData?.address1 ? rowData.address1 : "",
    address2: isEdit && rowData?.address2 ? rowData.address2 : "",
    city: isEdit && rowData?.city ? rowData.city : "",
    state: isEdit && rowData?.state ? rowData.state : "",
    pincode: isEdit && rowData?.pin ? rowData.pin : "",
    country: isEdit && rowData?.country ? rowData.country : "",
    lat: isEdit && rowData?.lat ? rowData.lat : "",
    long: isEdit && rowData?.long ? rowData.long : "",

    gymDescription: isEdit && rowData?.description ? rowData.description : "",
    wtfSharePer: isEdit && rowData?.wtf_share ? rowData.wtf_share : "",
    googleRating: isEdit && rowData?.google_rating ? rowData.google_rating : "",
    gmbUrl: isEdit && rowData?.gmb_url ? rowData.gmb_url : "",
    shortUrl: isEdit && rowData?.short_url ? rowData.short_url : "",

    leaseAgreeementFile:
      isEdit && rowData?.lease_agreement ? rowData.lease_agreement : "",
    electricityBillFile:
      isEdit && rowData?.electricity_bill ? rowData.electricity_bill : "",
    bankStatementFile:
      isEdit && rowData?.bank_statement ? rowData.bank_statement : "",

    is100mRestriction: isEdit && rowData?.is_100 ? true : false,
    isActive: isEdit && rowData?.status === "active" ? true : false,
    isDummy: isEdit && rowData?.is_dummy ? true : false,
    isPresale: isEdit && rowData?.is_pre_sale ? true : false,
    isRecurring: isEdit && rowData?.is_recurring ? true : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, type, checked } = e.target;

    setIsSubmit(false);

    if (type === "file") {
      const file = e.target.files[0];
      setFormValues((prevs) => ({
        ...prevs,
        [name]: file,
      }));
    } else {
      if (name === "pincode") {
        const value = e.target.value;
        if (value === "" || (!value.startsWith('-') && value.length <= 6)) {
          setFormValues((prevs) => ({
            ...prevs,
            [name]: value,
          }));
        }
      } else {
        setFormValues((prevs) => ({
          ...prevs,
          [name]:
            name === "gymSlug"
              ? slugify(e.target.value)
              : type === "checkbox"
              ? checked
              : e.target.value,
        }));
      }
    }
  };

  const handlePlaceChange = (selectedLocation) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      searchedLocation: selectedLocation.formatted_address,
      address1: selectedLocation.address1,
      address2: selectedLocation.address2,
      city: selectedLocation.city,
      state: selectedLocation.state,
      pincode: selectedLocation.pincode,
      country: selectedLocation.selectedCountry,
      lat: selectedLocation.lat,
      long: selectedLocation.long,
    }));
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  function getEndusers() {
    dispatch(
      fetchUsersData({
        token: userInfoData?.token,
        qps: `account_type=gym&status=active`,
        pageNo: 1,
        limit: 100,
      })
    );
  }

  function getgymCategories() {
    const filters = {
      page: 1,
      limit: 1000,
      status: "active",
    };

    dispatch(
      fetchGymCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleSubmitForm = async (requestBody) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_gym : add_gym;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      console.log("result=> ", result);

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    getEndusers();
    getgymCategories();
  }, []);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        user_id: formValues.selectedGymOwner?.value || "",
        name:
          formValues.selectedGymOwner?.info?.name ||
          formValues.selectedGymOwner?.label ||
          "",
        gym_name: formValues.gymName || "",
        slug: formValues.gymSlug || "",
        description: formValues.gymDescription || "",
        wtf_share: formValues.wtfSharePer || "",
        google_rating: formValues.googleRating || "",
        gmb_url: formValues.gmbUrl || "",
        short_url: formValues.shortUrl || "",
        lease_agreement: formValues.leaseAgreeementFile || "",
        electricity_bill: formValues.electricityBillFile || "",
        bank_statement: formValues.bankStatementFile || "",
        category_id: formValues.selectedGymCategory?.value || "",
        device_id: formValues.deviceID || "",
        status: formValues.isActive ? "active" : "inactive",
        is_100: formValues.is100mRestriction ? 1 : 0,
        is_dummy: formValues.isDummy ? 1 : 0,
        is_pre_sale: formValues.isPresale ? 1 : 0,
        is_recurring: formValues.isRecurring ? 1 : 0,
        type: "gym",
        modules: [
          "trainer",
          "member",
          "benefits",
          "addon",
          "events",
          "gallery",
          "equipments",
          "offers",
          "feedbacks",
          "subscription",
          "financial_reports",
          "sessions",
          "trainer_and_member_mapping",
          "workout_mapping",
          "diet_mapping",
        ],

        address1: formValues.address1 || "",
        address2: formValues.address2 || "",
        city: formValues.city || "",
        state: formValues.state || "",
        pin: formValues.pincode || "",
        country: formValues.country || "",
        lat: formValues.lat || "",
        long: formValues.long || "",

        plan_type: "",
        is_partial: "",
        is_cash: "",
        is_settlement: "",
        is_discount: "",
        cto: "",
        is_minimum: "",
        guarantee_value: "",
        poc_name: "",
        poc_mobile: "",
        is_gst: "",
        gst_number: "",
        is_gst_inclusive: "",
        account_number: "",
        ifsc_code: "",
        bank_name: "",
      };

      const formData = new FormData();

      for (const key in userData) {
        if (userData.hasOwnProperty(key)) {
          formData.append(key, userData[key]);
        }
      }

      if (isEdit) {
        formData.append("uid", rowData.uid);
      }

      const handleConfirm = async () => {
        handleSubmitForm(formData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer feature-docs">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add New"} Fitness Center`}
        btnTxt={isEdit ? "Update" : "Submit"}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoadingFormData}
      />

      <form className="formContainer">
        <div className="formInputsGrid fourGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedGymOwner" className="formInputLabel">
              gym owner <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedGymOwner ? "formError" : ""
              }`}>
              <SelectDropdown
                options={usersData && usersData?.length > 0 ? usersData : []}
                selectedOption={formValues.selectedGymOwner}
                setSelectedOption={(selectedValue) =>
                  setFormValues((prevs) => ({
                    ...prevs,
                    selectedGymOwner: selectedValue,
                  }))
                }
                name="Gym Owner"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedGymCategory" className="formInputLabel">
              gym category <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedGymCategory ? "formError" : ""
              }`}>
              <SelectDropdown
                options={
                  gymCategories && gymCategories?.length > 0
                    ? gymCategories
                    : []
                }
                selectedOption={formValues.selectedGymCategory}
                setSelectedOption={(selectedValue) =>
                  setFormValues((prevs) => ({
                    ...prevs,
                    selectedGymCategory: selectedValue,
                  }))
                }
                name="Gym Category"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="deviceID" className={`formInputLabel `}>
              device ID
            </label>

            <input
              type="text"
              placeholder="Enter Text"
              className={`formInput ${formErrors?.deviceID ? "formError" : ""}`}
              name="deviceID"
              value={formValues.deviceID}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="gymName" className={`formInputLabel `}>
              gym name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Text"
              className={`formInput ${formErrors?.gymName ? "formError" : ""}`}
              name="gymName"
              value={formValues.gymName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="gymSlug" className={`formInputLabel `}>
              slug <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Text"
              className={`formInput ${formErrors?.gymSlug ? "formError" : ""}`}
              name="gymSlug"
              value={formValues.gymSlug}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox searchInput">
            <label htmlFor="searchedLocation" className="formInputLabel">
              Search location
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.searchedLocation && "formError"
              }`}>
              <PlacesSearch handlePlaceChange={handlePlaceChange} />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="address1" className="formInputLabel">
              Address 1 <span className="required">*</span>
            </label>

            <input
              type="text"
              className={`formInput ${formErrors.address1 && "formError"}`}
              name="address1"
              placeholder="Enter Your Address"
              value={formValues.address1}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="address2" className="formInputLabel">
              Address 2 <span className="required">*</span>
            </label>

            <input
              type="text"
              className={`formInput ${formErrors.address2 && "formError"}`}
              name="address2"
              placeholder="Enter Your Address"
              value={formValues.address2}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="city" className="formInputLabel">
              City <span className="required">*</span>
            </label>

            <input
              type="text"
              className={`formInput ${formErrors.city && "formError"}`}
              name="city"
              placeholder="Enter Your city"
              value={formValues.city}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="state" className="formInputLabel">
              state <span className="required">*</span>
            </label>

            <input
              type="text"
              className={`formInput ${formErrors.state && "formError"}`}
              name="state"
              placeholder="Enter Your state"
              value={formValues.state}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="pincode" className="formInputLabel">
              pin <span className="required">*</span>
            </label>

            <input
              type="number"
              className={`formInput ${formErrors.pincode && "formError"}`}
              name="pincode"
              placeholder="Enter Your pincode"
              value={formValues.pincode}
              onChange={onChangeInput}
              min="0"
              maxLength={6}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="country" className="formInputLabel">
              Country <span className="required">*</span>
            </label>

            <input
              type="text"
              className={`formInput ${formErrors.country && "formError"}`}
              name="country"
              placeholder="Enter Your country"
              value={formValues.country}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="lat" className="formInputLabel">
              latitute <span className="required">*</span>
            </label>

            <input
              type="number"
              className={`formInput ${formErrors.lat && "formError"}`}
              name="lat"
              placeholder="Gym Latitute"
              value={formValues.lat}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="long" className="formInputLabel">
              longitute <span className="required">*</span>
            </label>

            <input
              type="number"
              className={`formInput ${formErrors.long && "formError"}`}
              name="long"
              placeholder="Gym Latitute"
              value={formValues.long}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="wtfSharePer" className="formInputLabel">
              WTF Share (In Percentage)
            </label>

            <input
              type="number"
              className={`formInput ${formErrors.wtfSharePer && "formError"}`}
              name="wtfSharePer"
              placeholder="Enter Longitute"
              value={formValues.wtfSharePer}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="googleRating" className="formInputLabel">
              Google Rating (Out Of 5) <span className="required">*</span>
            </label>

            <input
              type="number"
              className={`formInput ${formErrors.googleRating && "formError"}`}
              name="googleRating"
              placeholder="Enter Rating"
              value={formValues.googleRating}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="gmbUrl" className="formInputLabel">
              GMB URL <span className="required">*</span>
            </label>

            <input
              type="text"
              className={`formInput ${formErrors.gmbUrl && "formError"}`}
              name="gmbUrl"
              placeholder="Enter GMB URL"
              value={formValues.gmbUrl}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="shortUrl" className="formInputLabel">
              Short URL <span className="required">*</span>
            </label>

            <input
              type="text"
              className={`formInput ${formErrors.shortUrl && "formError"}`}
              name="shortUrl"
              placeholder="Enter Short URL"
              value={formValues.shortUrl}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="leaseAgreeementFile" className={`formInputLabel`}>
              Lease Agreement
            </label>

            <div className="multi-row-features">
              <div className="commonWrapper">
                <input
                  accept="image/*,.pdf"
                  type="file"
                  placeholder="Enter URL"
                  className={`formInput ${
                    formErrors.leaseAgreeementFile ? "formError" : ""
                  }`}
                  name="leaseAgreeementFile"
                  onChange={onChangeInput}
                />
              </div>
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="electricityBillFile" className={`formInputLabel`}>
              electricity bill
            </label>

            <div className="multi-row-features">
              <div className="commonWrapper">
                <input
                  accept="image/*,.pdf"
                  type="file"
                  placeholder="Enter URL"
                  className={`formInput ${
                    formErrors.electricityBillFile ? "formError" : ""
                  }`}
                  name="electricityBillFile"
                  onChange={onChangeInput}
                />
              </div>
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="bankStatementFile" className={`formInputLabel`}>
              bank statement
            </label>

            <div className="multi-row-features">
              <div className="commonWrapper">
                <input
                  accept="image/*,.pdf"
                  type="file"
                  placeholder="Enter URL"
                  className={`formInput ${
                    formErrors.bankStatementFile ? "formError" : ""
                  }`}
                  name="bankStatementFile"
                  onChange={onChangeInput}
                />
              </div>
            </div>
          </div>

          <div className="formInputBox span4">
            <label htmlFor="gymDescription" className="formInputLabel">
              Description
              {/* (Max 100 Characters -{" "}
              {formValues.gymDescription?.length || 0}){" "} */}
              <span className="required">*</span>
            </label>

            <textarea
              name="gymDescription"
              className={`formInput ${
                formErrors.gymDescription ? "formError" : ""
              }`}
              placeholder="Enter Details"
              value={formValues.gymDescription}
              onChange={onChangeInput}></textarea>
          </div>
        </div>

        <div className="formInputsGrid fourGridSystem">
          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.is100mRestriction ? "formError" : ""
            }`}>
            <Form.Check
              type="switch"
              name="is100mRestriction"
              label={`100M Restriction`}
              checked={formValues.is100mRestriction}
              onChange={onChangeInput}
            />
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}>
            <Form.Check
              type="switch"
              name="isActive"
              label={`${formValues.isActive ? "Active" : "Not Active"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isPresale ? "formError" : ""
            }`}>
            <Form.Check
              type="switch"
              name="isPresale"
              label={`${formValues.isPresale ? "Presale" : "Not Presale"}`}
              checked={formValues.isPresale}
              onChange={onChangeInput}
            />
          </div>
          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isRecurring  ? "formError" : ""
            }`}>
            <Form.Check
              type="switch"
              name="isRecurring"
              label={`${formValues.isRecurring ? "Recurring" : "Not Recurring"}`}
              checked={formValues.isRecurring}
              onChange={onChangeInput}
            />
          </div>
          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isDummy ? "formError" : ""
            }`}>
            <Form.Check
              type="switch"
              name="isDummy"
              label={`${formValues.isDummy ? "Dummy Gym" : "Not Dummy"}`}
              checked={formValues.isDummy}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default FitnessCenterForm;
